import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagFM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m25 10.87 1.08 3.322h3.493l-2.826 2.052 1.08 3.322L25 17.513l-2.826 2.053 1.08-3.322-2.826-2.052h3.493L25 10.87ZM10.87 25.001l3.322-1.079v-3.493l2.052 2.826 3.322-1.08-2.053 2.826 2.053 2.825-3.322-1.079-2.052 2.826V26.08l-3.322-1.079ZM25.001 39.132l-1.08-3.322H20.43l2.826-2.052-1.08-3.322 2.826 2.053 2.825-2.053-1.079 3.322 2.826 2.052H26.08l-1.079 3.322ZM39.132 25.001l-3.322 1.08v3.492l-2.052-2.826-3.322 1.08L32.49 25l-2.053-2.825 3.322 1.079 2.052-2.826v3.493L39.133 25Z"
}));
FlagFM.displayName = 'FlagFM';
export default withFlagWrapper(FlagFM);
//# sourceMappingURL=index.js.map